import { DEFAULT_ID } from 'prose-core'
import { Plugin, PluginKey } from 'prosemirror-state'
import { Slice } from 'prosemirror-model'
import { last } from 'lodash'
import { ourUuid } from 'utils'
import { preserveSelection } from 'common/Prose/utils'

export const BlockIdPluginKey = new PluginKey('blockId')

export const BlockIdFixMetaKey = 'blockIdFix'

export const BlockIdPlugin = new Plugin({
  key: BlockIdPluginKey,
  appendTransaction: (trs, oldState, newState) => {
    for (const transaction of trs) {
      // No need to run if user didn't generate transaction
      if (transaction.getMeta('realTime')) return
    }

    if (trs.every((tr) => !tr.docChanged)) return

    // check if we inserted a new node somewhere
    if (
      trs.every((tr) =>
        tr.steps.every(
          (step) =>
            'slice' in step &&
            // TODO: Fix this the next time the file is edited.
            // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
            (step as unknown as { slice: Slice }).slice.content.content!.every((node) => node.isText),
        ),
      )
    )
      return

    const usedBlockIds: { [key: string]: boolean } = {} // this is an object for faster lookup
    const { tr } = newState

    // Get list of uuids, update any bad/missing/duplicates
    newState.doc.forEach((curNode, curNodeOffset, curNodeIndex) => {
      const { blockId } = curNode.attrs
      if (!blockId || usedBlockIds[blockId] || blockId === DEFAULT_ID) {
        // Block id is missing, duplicate or default id. Generate new and update state

        const newId = ourUuid()
        tr.setNodeMarkup(curNodeOffset, undefined, {
          ...curNode.attrs,
          blockId: newId,
        })

        usedBlockIds[newId] = true
      } else {
        // Mark block id as taken
        usedBlockIds[curNode.attrs.blockId] = true
      }
    })

    if (tr.docChanged) {
      preserveSelection(tr, newState)
      // NOTE: keep stored marks when fixing
      // TODO: Fix this the next time the file is edited.
      // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
      if (last(trs)?.storedMarks) tr.setStoredMarks(last(trs)!.storedMarks!)
      tr.setMeta(BlockIdFixMetaKey, true)

      return tr
    }
  },
})
